// extracted by mini-css-extract-plugin
export default {"refresh":"Refresh_refresh__HTadt"};